<script>
import Multiselect from 'vue-multiselect'
import { appSectionsMethods  } from '@state/helpers'
import VueIconPicker from '@components/vue-icon-picker'

let _ = require('lodash')

export default {
    name: 'AppSectionsCreateForm',
    components: { Multiselect, 'vue-icon-picker': VueIconPicker },
    props: {
        onformsubmit: {
            type: Function,
            required: true
            },
        validator: {
            type: Object,
            required: true
            },
        form: {
            type: Object,
            required: true
            }
    },
    data() {
        return {
            icon: { name: "", type: "fontawesome", color: "#000000" },
            appSectionsOptions: [],
            appSectionsOptionsCache: [],
            appSectionsOptionsMounted: false,
            loadingAppSectionsOptions: false
        }
    },
    watch: {
        icon: function (value) {
            this.form.icon_name = value ? value.name : ""
        },
    },
    mounted(){
        this.populateAppSectionsOptions()
    },
    methods: {
        ...appSectionsMethods,
        populateAppSectionsOptions(searchQuery){
            let context = this
            context.loadingAppSectionsOptions = true
            let reqParams = context.$select_params(searchQuery)
            const promise = context.fetchAppSections(reqParams)
            return promise.then(data => {
                let listOptions = []
                data.results.forEach(opt => {
                    let parentTreeName = ''
                    if (opt.parent_tree.length - 1){
                        for (let i = 0; i < opt.parent_tree.length; i++) {
                            if(i !== (opt.parent_tree.length - 1)){
                                const el = opt.parent_tree[i];
                                parentTreeName = parentTreeName.concat(`${el.name} > `)
                            }
                        }
                    }
                    parentTreeName = parentTreeName.concat(opt.name)
                    listOptions.push({
                        'url': opt.url,
                        'name': opt.name,
                        parentTreeName
                    })
                });
                context.appSectionsOptions = listOptions
                context.appSectionsOptionsMounted = true
                context.loadingAppSectionsOptions = false
            }).catch(error => {
                context.$axios_error_noty(error, context)
                context.appSectionsOptionsMounted = true
                context.loadingAppSectionsOptions = false
            })
        },
        asyncFindAppSections: _.debounce(function (searchQuery) {
            this.populateAppSectionsOptions(searchQuery)
        }, 600),

        labelOfAppSectionsOptions(opt){
            let appSectionsOptionsFounded = this.appSectionsOptions.find(x => x.url === opt)
            if (!appSectionsOptionsFounded){
                let cacheFounded = this.appSectionsOptionsCache.find(x => x.url === opt)
                return  cacheFounded ? cacheFounded.parentTreeName : this.appSectionsOptionsMounted ? `Not found in options: ${opt}`: ''
            }else{
                if (this.form.category === opt){ // === When is a single option select
                    if (!this.appSectionsOptionsCache.find(x => x.url === opt)){
                        this.appSectionsOptionsCache.push(appSectionsOptionsFounded)
                    }
                } 
                return appSectionsOptionsFounded.parentTreeName
            }
        },

    }
}
</script>
<template>
    <b-form  id="form" @submit="onformsubmit" >
        <form-wrapper :validator="validator ">
        <div>
            <form-summary/>
        </div>
        <form-group name="name" label="Nombre">
            <b-form-input
                v-model="form.name"
                slot-scope="{ attrs, listeners }"
                v-bind="attrs"
                v-on="listeners"
            /> 
        </form-group>  
        <form-group name="path" label="Ruta">
            <b-form-input
                v-model="form.path"
                slot-scope="{ attrs, listeners }"
                v-bind="attrs"
                v-on="listeners"
            /> 
        </form-group>
        <form-group name="hover_text" label="Título">
            <b-form-input
                v-model="form.hover_text"
                slot-scope="{ attrs, listeners }"
                v-bind="attrs"
                v-on="listeners"
            /> 
        </form-group>
        <vue-icon-picker v-model="icon" :form-field="form.icon_name" input-name="icon_name" label="icon"/>
        <form-group name="app-sections-select" label="¿Es un submenu de?">
            <Multiselect
                id="app-sections-select"
                v-model="form.parent"
                :multiple="false"
                :options="appSectionsOptions.map(x => x.url)" 
                :custom-label="opt => labelOfAppSectionsOptions(opt)"
                :loading="loadingAppSectionsOptions"
                :internal-search="false"
                @search-change="asyncFindAppSections"
                placeholder="Sección"
                selectLabel="+"
                deselectLabel="×"
                selectedLabel=✔︎
                >
            </Multiselect>
        </form-group>  
        <b-row>
            <b-col>
                <form-group>
                    <b-form-checkbox
                        v-model="form.app_permission"
                        :value="true"
                        :unchecked-value="false"
                    >
                        ¿Requiere permiso?
                    </b-form-checkbox>
                </form-group>
            </b-col>
            <b-col v-if="form.app_permission_detail">
                <b-card
                    no-body
                    tag="article"
                    class="mb-0"
                >
                <b-card-body class="pt-0">
                    <b-card-title>Información del Permiso de Sección</b-card-title>
                    <b-card-text>
                        <b>Codename:</b> {{form.app_permission_detail.permission.codename}} <br>
                        <b>Name:</b> {{form.app_permission_detail.permission.name}} <br>
                    </b-card-text>
                </b-card-body>
                </b-card>
            </b-col>
        </b-row>
                <form-group>
            <b-form-checkbox
                v-model="form.admin_required"
                :value="true"
                :unchecked-value="false"
            >
                ¿Requiere ser administrador?
            </b-form-checkbox>
        </form-group>
        </form-wrapper>
    </b-form>
</template>